var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('c-popover', {
    ref: "app_panel",
    staticClass: "app_panel",
    class: {
      is_collapsed: _vm.isCollapsed,
      is_dragging: _vm.isDragging,
      is_resizing: _vm.isResizing
    },
    attrs: {
      "is-resizable": !_vm.isCollapsed,
      "max-width": _vm.maxWidth,
      "resize-handle-color": _vm.computedResizeHandleColor,
      "resize-handle-icon-color": _vm.computedResizeHandleIconColor,
      "draggable-handle": ".handle",
      "is-draggable": "",
      "keep-open": ""
    },
    domProps: {
      "isOpen": true,
      "position": _vm.positionOverride
    },
    on: {
      "c-dragging": _vm.onDrag,
      "c-position-changed": _vm.onPositionChanged,
      "c-resizing": _vm.onResize,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.emitPanelClose.apply(null, arguments);
      }
    }
  }, [_c('c-card', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border-color": _vm.computedBorderColor,
      "border-size": "4px",
      "background-color": "#fff",
      "remove-shadow": ""
    },
    domProps: {
      "collapsed": _vm.isCollapsed,
      "collapsible": false
    }
  }, [_c('div', {
    staticClass: "handle c-flex align-items-center pa-2",
    staticStyle: {
      "width": "100%",
      "border-bottom": "1px solid currentColor",
      "height": "100%",
      "user-select": "none"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._t("icon", function () {
    return [_c('ButtonMiniAction', {
      attrs: {
        "icon": "fa-etch fa-solid fa-circle-info",
        "icon-color": "var(--v-info-base)",
        "icon-size": "18px",
        "disable-scale-on-hover": ""
      },
      on: {
        "dblclick": _vm.emitPanelClose
      }
    })];
  }), _c('div', {
    staticClass: "text-truncate",
    staticStyle: {
      "font-size": "16px",
      "flex-grow": "1",
      "text-align": "center"
    }
  }, [_vm._t("title")], 2), _c('div', {
    staticClass: "c-flex"
  }, [_vm.collapsible && _vm.isCollapsed ? _c('ButtonMiniAction', {
    attrs: {
      "icon": "fa-light fa-arrow-up-right-and-arrow-down-left-from-center",
      "icon-color": "var(--cosmic-text)",
      "icon-size": "18px",
      "label": "Maximize panel",
      "tooltip": "Maximize panel"
    },
    on: {
      "click": function ($event) {
        _vm.isCollapsed = false;
      }
    }
  }) : _vm._e(), _vm.collapsible && !_vm.isCollapsed ? _c('ButtonMiniAction', {
    attrs: {
      "icon": "fa-light fa-arrow-down-left-and-arrow-up-right-to-center",
      "icon-color": "var(--cosmic-text)",
      "icon-size": "18px",
      "label": "Minimize panel",
      "tooltip": "Minimize panel"
    },
    on: {
      "click": function ($event) {
        _vm.isCollapsed = true;
      }
    }
  }) : _vm._e(), _c('ButtonMiniAction', {
    attrs: {
      "icon": _vm.$icons.close,
      "icon-color": "var(--cosmic-gray-base)",
      "icon-size": "18px",
      "tooltip": "Close",
      "tooltip-position": "bottom right"
    },
    on: {
      "click": _vm.emitPanelClose
    }
  })], 1)], 2), _c('div', {
    attrs: {
      "slot": "after-title"
    },
    slot: "after-title"
  }), _vm._t("content"), _vm.$slots.actions ? _c('div', {
    staticClass: "py-2",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_vm._t("actions")], 2) : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };